<template>
  <div class="no-uesdMeetingRoom">
    <img src="@/assets/images/empty.png" alt="" />
    <div>{{ $t('暂无信息') }}</div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Icon } from 'vant'
Vue.use(Icon)
export default {
  name: 'NoDataWarning',
  data() {
    return {}
  },
}
</script>
<style lang="less" scoped>
.no-uesdMeetingRoom {
  margin-top: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;
  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}
</style>
